import { getObjects, createObject, updateObject, deleteObject, exportObjects, exportFile_Bilan } from "../../../services/services";
import Conditions from "../../../assets/files/conditions.json";

const combboxElements = [
  { label: "Element A 1001", value: 1 },
  { label: "Element B 1002", value: 2 },
];
export const CSTR_RequirementsConfig = {
  title: "CSTR_Requirements",
  entityLabel: "CSTR_Requirement",

  idField: "id",

  rowActions: [
    { key: "info", label: "Info", permission: "view_pbsElements", action: "info" },
    { key: "edit", label: "Edit", permission: "edit_pbsElements", action: "edit" },
    { key: "delete", label: "Delete", permission: "delete_pbsElements", action: "delete" }
  ],

  actionHandlers: {
    info: ({ entity, setState, setFormParams }) => {
    setState("info");
    setFormParams([entity]);
    },
    edit: ({ entity, setState, setFormParams }) => {
      setState("edit");
      setFormParams([entity]);
    },
    delete: async ({ entity, setEntityToDelete }) => {
      setEntityToDelete(entity);
    },
  },

  services: {
    list: getObjects,
    create: createObject,
    update: updateObject,
    delete: deleteObject,
    export: exportObjects,
    export_bilan: exportFile_Bilan,
    filters: "show",
    columns: "show",

    services_url_names: {
    list: "get_CSTR_Requirements",
    create: "create_cstr_requirement",
    update: "update_cstr_requirement",
    delete: "delete_cstr_requirement",
    export: "export_CSTR_Requirement",
    export_bilan: "export_cstr_requirements_bilan",
    },
  },
  

  attributes: [
    { label: "id", value: "id", type: "int", is_default:"true"},
    { label: "element_id", value: "element_id", type: "int", is_default:"true" },
    { label: "element__pbscode", value: "element__pbscode", type: "str" },
    { label: "requirement_name", value: "requirement_name", type: "str", is_default:"true" },
    { label: "value_plus_or_minus", value: "value_plus_or_minus", type: "float", is_default:"true" },
    { label: "created_at", value: "created_at", type: "date" },
    { label: "updated_at", value: "updated_at", type: "date" }, 
  ],
  
  conditions: Conditions,

  formFields: [
    { key: 'element_id', label: 'element_id', type: 'Autocomplete', Autocomplete:combboxElements, placeholder:'Select PBS element', validation: 'required' },
    { key: "requirement_name", label: "requirement_name",type: 'input' },
    { key: "value_plus_or_minus", label: "value_plus_or_minus",type: 'input' },
  ],

   defaultFilters : [],


  // =========================
  // TABS CONFIG (CUSTOM PER ENTITY)
  // =========================
  tabs: [
    {
      label: "All",
      filters: [],   // tabIndex 0
    },
    {
      label: "HFI",
      filters: [{attribute:'pbscode',condition:'start',value:'1.1',type:'str'}],   // tabIndex 1
     
    },
    {
      label: "LFI",
      filters: [{attribute:'pbscode',condition:'start',value:'1.2',type:'str'}],   // tabIndex 2
       
    },
  ],
};
